import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.37132 6.62868C8.19975 5.45711 6.30025 5.45711 5.12868 6.62868L2.12868 9.62868C0.957107 10.8003 0.957107 12.6997 2.12868 13.8713C3.30025 15.0429 5.19975 15.0429 6.37132 13.8713L7.19749 13.0451M6.62868 9.37132C7.80025 10.5429 9.69975 10.5429 10.8713 9.37132L13.8713 6.37132C15.0429 5.19975 15.0429 3.30025 13.8713 2.12868C12.6997 0.957107 10.8003 0.957107 9.62868 2.12868L8.80397 2.95339",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }